export default "__VITE_ASSET__09ab69cc__"